<template>
    <div>
        <div class="content-wrapper">
            <section class="content-header">
                <h1>
                    Labelisation
                    <small>Gestion des labels et subventions</small>
                </h1>
                <ol class="breadcrumb">
                    <li><a href="#"><i class="fa fa-dashboard"></i> Accueil</a></li>
                    <li class="active">Labelisation</li>
                </ol>
            </section>

            <section class="content">
                <div class="row">
                    <div class="col-md-12">
                        <div class="nav-tabs-custom nav-tabs-custom-bottom">
                            <ul class="nav nav-tabs" role="tablist">
                                <li :class="active==1 ? 'active' : '' ">
                                    <a href="#label_tab_1"
                                       aria-controls="#label_tab_1"
                                       data-toggle="tab"
                                       @click="active=1"
                                       aria-expanded="false">Labélisations effectuées</a>
                                </li>
                                <li :class="active==2 ? 'active' : '' ">
                                    <a href="#label_tab_2"
                                       aria-controls="#label_tab_2"
                                       data-toggle="tab"
                                       @click="active=2"
                                       aria-expanded="false">Calcul des subventions</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="row tab-content">
                    <div role="tabpanel" :class="active==1 ? 'active' : '' " class="col-md-12 tab-pane" id="label_tab_1">
                        <LabelisationsEffectuees></LabelisationsEffectuees>
                    </div>

                    <div role="tabpanel" :class="active==2 ? 'active' : '' " class="col-md-12 tab-pane" id="label_tab_2">
                        <Subventions :annee="getAnnee()"></Subventions>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import LabelisationsEffectuees from './LabelisationsEffectuees'
    import Subventions from './Subventions'

    export default {
        data() {
            return {
                loading: false,
                active: 1
            }
        },
        computed: {
            ...mapGetters({
                getRoute: 'getRoute',
            })
        },
        methods: {
            getAnnee() {
                return this.$route.params.annee || new Date().getFullYear()
            }
        },
        components: {
            LabelisationsEffectuees,
            Subventions
        }
    }
</script> 


// WEBPACK FOOTER //
// src/components/Labelisation/Labelisation_general.vue